import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IHomePageAdmin_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePageAdmin_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  B2BGetRolesById: any[];
  B2BGetRolesById_dummy: any[];
  B2BHomepageAdminSummary: any[];
  B2BHomepageAdminSummary_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
}

export class HomePageAdmin_ScreenBase extends React.PureComponent<
  IHomePageAdmin_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;

  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 854764,
          PropertyName: "value",
          Value: "Hızlı Erişim",
          TagName: "Label17_value",
        },
        {
          Id: 107486,
          PropertyName: "value",
          Value: "Merhaba,",
          TagName: "Label20_value",
        },
        {
          Id: 80150,
          PropertyName: "value",
          Value: "Bildirim Oluştur",
          TagName: "Label13_value",
        },
        {
          Id: 367993,
          PropertyName: "value",
          Value: "Raporlar",
          TagName: "Label19_value",
        },
        {
          Id: 711242,
          PropertyName: "value",
          Value: "Müşteriler",
          TagName: "Label25_value",
        },
        {
          Id: 582174,
          PropertyName: "value",
          Value: "Koleksiyonlar",
          TagName: "Label26_value",
        },
        {
          Id: 162570,
          PropertyName: "value",
          Value: "Bildirimler",
          TagName: "Label29_value",
        },
        {
          Id: 955470,
          PropertyName: "value",
          Value: "Çok Satanlar",
          TagName: "Label30_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 854764,
          PropertyName: "value",
          Value: "Quick Access",
          TagName: "Label17_value",
        },
        {
          Id: 107486,
          PropertyName: "value",
          Value: "Hello,",
          TagName: "Label20_value",
        },
        {
          Id: 80150,
          PropertyName: "value",
          Value: "Create Notification",
          TagName: "Label13_value",
        },
        {
          Id: 367993,
          PropertyName: "value",
          Value: "Reports",
          TagName: "Label19_value",
        },
        {
          Id: 711242,
          PropertyName: "value",
          Value: "Customers",
          TagName: "Label25_value",
        },
        {
          Id: 582174,
          PropertyName: "value",
          Value: "Collections",
          TagName: "Label26_value",
        },
        {
          Id: 162570,
          PropertyName: "value",
          Value: "Notifications",
          TagName: "Label29_value",
        },
        {
          Id: 955470,
          PropertyName: "value",
          Value: "Best Sellers",
          TagName: "Label30_value",
        },
      ],
    },
    {
      Id: "245f1a50-ee83-44d4-ac2e-1054e32dc662",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 107486, PropertyName: "value", Value: "Merhaba," },
        { Id: 854764, PropertyName: "value", Value: "Hızlı Erişim" },
        { Id: 80150, PropertyName: "value", Value: "Bildirim Oluştur" },
        { Id: 367993, PropertyName: "value", Value: "Raporlar" },
        { Id: 711242, PropertyName: "value", Value: "Müşteriler" },
        { Id: 582174, PropertyName: "value", Value: "Koleksiyonlar" },
        { Id: 162570, PropertyName: "value", Value: "Bildirimler" },
        { Id: 955470, PropertyName: "value", Value: "Çok Satanlar" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      B2BGetRolesById: [],
      B2BHomepageAdminSummary: [],
      NAVIGATE: "",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "homepageadmin",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.HomePageAdminPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.HomePageAdminPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("homepageadmin", "footer_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepageadmin", "footer_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePageAdminPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.HomePageAdminPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePageAdminPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePageAdmin/HomePageAdminPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    formVars.homepageadmin_103524_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].fullName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].fullName
        : null
    );
    stateVars.B2BHomepageAdminSummary = result?.data.b2BHomepageAdminSummary;
    formVars.homepageadmin_31721_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BHomepageAdminSummary !== undefined
        ? stateVars.B2BHomepageAdminSummary?.length > 0
          ? stateVars.B2BHomepageAdminSummary[0].aktifKullaniciSayisi
          : null
        : this.state.B2BHomepageAdminSummary?.length > 0
        ? this.state.B2BHomepageAdminSummary[0].aktifKullaniciSayisi
        : null
    );
    formVars.homepageadmin_519153_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BHomepageAdminSummary !== undefined
        ? stateVars.B2BHomepageAdminSummary?.length > 0
          ? stateVars.B2BHomepageAdminSummary[0].aktifKoleksiyonSayisi
          : null
        : this.state.B2BHomepageAdminSummary?.length > 0
        ? this.state.B2BHomepageAdminSummary[0].aktifKoleksiyonSayisi
        : null
    );
    formVars.homepageadmin_850608_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BHomepageAdminSummary !== undefined
        ? stateVars.B2BHomepageAdminSummary?.length > 0
          ? stateVars.B2BHomepageAdminSummary[0].aktifBildirimSayisi
          : null
        : this.state.B2BHomepageAdminSummary?.length > 0
        ? this.state.B2BHomepageAdminSummary[0].aktifBildirimSayisi
        : null
    );
    formVars.homepageadmin_659368_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BHomepageAdminSummary !== undefined
        ? stateVars.B2BHomepageAdminSummary?.length > 0
          ? stateVars.B2BHomepageAdminSummary[0].cokSatanDesenSayisi
          : null
        : this.state.B2BHomepageAdminSummary?.length > 0
        ? this.state.B2BHomepageAdminSummary[0].cokSatanDesenSayisi
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageAdminPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePageAdminPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepageadmin_103524_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].fullName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].fullName
        : null
    );

    formVars.homepageadmin_31721_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BHomepageAdminSummary !== undefined
        ? stateVars.B2BHomepageAdminSummary?.length > 0
          ? stateVars.B2BHomepageAdminSummary[0].aktifKullaniciSayisi
          : null
        : this.state.B2BHomepageAdminSummary?.length > 0
        ? this.state.B2BHomepageAdminSummary[0].aktifKullaniciSayisi
        : null
    );

    formVars.homepageadmin_519153_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BHomepageAdminSummary !== undefined
        ? stateVars.B2BHomepageAdminSummary?.length > 0
          ? stateVars.B2BHomepageAdminSummary[0].aktifKoleksiyonSayisi
          : null
        : this.state.B2BHomepageAdminSummary?.length > 0
        ? this.state.B2BHomepageAdminSummary[0].aktifKoleksiyonSayisi
        : null
    );

    formVars.homepageadmin_850608_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BHomepageAdminSummary !== undefined
        ? stateVars.B2BHomepageAdminSummary?.length > 0
          ? stateVars.B2BHomepageAdminSummary[0].aktifBildirimSayisi
          : null
        : this.state.B2BHomepageAdminSummary?.length > 0
        ? this.state.B2BHomepageAdminSummary[0].aktifBildirimSayisi
        : null
    );

    formVars.homepageadmin_659368_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BHomepageAdminSummary !== undefined
        ? stateVars.B2BHomepageAdminSummary?.length > 0
          ? stateVars.B2BHomepageAdminSummary[0].cokSatanDesenSayisi
          : null
        : this.state.B2BHomepageAdminSummary?.length > 0
        ? this.state.B2BHomepageAdminSummary[0].cokSatanDesenSayisi
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePageAdminComponent_336799_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/adminnotifmanagement") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePageAdmin",
      "AdminNotifManagement",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageAdminComponent_507048_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/reportsfirstpage") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePageAdmin",
      "ReportsFirstPage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePageAdminPageInit();
    }
  }
}
